module.exports = __webpack_public_path__ + "img/business_in_transition.59afd6e9.svg";